<template>
  <div class="widget" v-if="perShift && perShift.id">
    <div class="widget-title">
      <!-- <v-icon>{{ getIconByShift(perShift.id) }}</v-icon> -->
      {{ perShift.name }}
    </div>

    <div class="widget-content">
      <div 
        class="widget-item monthly" 
        v-if="settings.value.show_goal"
      >
        Monthly Goal :
        <span class="value goal">
          {{ perShift[useByPaymentCapacity('monthly')].goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item current"
        v-if="settings.value.show_current_total_value"
      >
        Current Total :
        <span class="value total">
          <template v-if="target_type === 'Amount'">
            {{ perShift[useByPaymentCapacity('monthly')][useNetAmount()] | numFormat(currency) }}
          </template>
          <template v-else>
            {{ perShift[useByPaymentCapacity('monthly')][useNetCount] | numFormat }}
          </template>
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div 
        class="widget-item per-day" 
        v-if="settings.value.show_needed_per_day"
      >
        Needed Per Day :
        <span class="value needed">
          {{ perShift[useByPaymentCapacity('daily')].goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div 
        class="widget-item per-day" 
        v-if="settings.value.show_needed_per_week"
      >
        Needed Per Week :
        <span class="value needed">
          {{ perShift[useByPaymentCapacity('weekly')].goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div 
        class="widget-item working-days"
        v-if="settings.value.show_working_days && perShift[useByPaymentCapacity('monthly')]"
      >
        Days : Working -
        <span class="value days">
          {{ perShift[useByPaymentCapacity('monthly')].days.working | dayFormat }}
        </span>
        | Left - <span class="value days">
          {{ perShift[useByPaymentCapacity('monthly')].days.remaining | dayFormat }}
        </span>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";
// import SendCongratulation from "@/mixins/send_congratulation";

export default {
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
    // neededPerDay() {
    //   if (!this.perShift.id) { return 0; }
    //   const monthly = this.perShift.monthly;

    //   let monthly_value = 0;
    //   if (this.settings.value.target_type === 'Count') {
    //     monthly_value = monthly.count;
    //   } else {
    //     monthly_value = monthly[this.useNetAmount()];
    //   }

    //   if (monthly.goal > monthly_value) {
    //     return (monthly.goal - monthly_value) / (monthly.days.remaining || 1);
    //   } else {
    //     return monthly.goal / (monthly.days.working || 1);
    //   }
    // },
    // neededPerWeek() {
    //   if (!this.perShift.id) { return 0; }
    //   return this.neededPerDay * this.perShift.weekly.days.working;
    // },
    listeningAgents() {
      return this.perShift?.agents || [];
    },
  },
};
</script>